"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var teamAssociationRule_exports = {};
__export(teamAssociationRule_exports, {
  teamAssociationRule: () => teamAssociationRule
});
module.exports = __toCommonJS(teamAssociationRule_exports);
var import_topo_core = require("@cartographerio/topo-core");
var import_permission = require("@cartographerio/permission");
const teamAssociationRule = ({ project, identity, graph }) => (survey) => {
  const { teamId } = survey;
  const isAdmin = (0, import_permission.permissionCheckPasses)(
    import_permission.checks.workspace.admin(graph.findWorkspaceByProjectId(project.id).id),
    {
      id: identity.userId,
      roles: identity.roles,
      qualificationRoles: identity.qualificationRoles
    },
    graph
  );
  return teamId == null || project.teamIds.includes(teamId) ? [] : [(0, import_topo_core.createMessage)(isAdmin ? "info" : "error", `This team is not associated with the ${project.name} project`)];
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  teamAssociationRule
});
//# sourceMappingURL=teamAssociationRule.js.map
